module.exports = __webpack_public_path__ + "media/handclick.769bb01b.svg";